export default function validation(response, messages, i18nType) {
  if (!response.data.error || !response.data.error.validationErrors) {
    return;
  }

  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('DEVIS_COMMANDE_SANS_SUITE_DELETE_FORBIDDEN_IF_BLOCAGE_VALIDATION|') === 0) {
      messages.push({
        message: i18nType + '.SansSuiteForbiddenMoveWithValidationBlocage',
      });
    } else if (message.indexOf('|') !== -1) {
      const elements = message.split('|')[0].split('@');
      const params = {};
      for (let i = 1; i < elements.length; i += 1) {
        params['param' + i] = elements[i];
      }
      messages.push({
        message: i18nType + '.apiMessages.' + elements[0],
        parametres: params,
      });
    } else {
      messages.push({
        message: message,
      });
    }
  });
}
